import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { userManagementBaseUrl, userManagement } from "../endpoints";

export const tokenMechanismMasterService = createApi({
  reducerPath: "tokenMechanismMasterService",
  baseQuery: fetchBaseQuery({ baseUrl: userManagementBaseUrl }),
  tagTypes: ["tokenMechanismMaster"],
  endpoints: (builder) => ({
    getAllTokenMechanismMasters: builder.mutation({
      query: (body) => ({
        url: userManagement.tokenMechanismMasterController.getAll,
        method: "GET",
        headers: { Authorization: `Bearer ${body.token}` },
      }),
    }),
    getTokenMechanismMasterById: builder.mutation({
      query: (body) => ({
        url: `${userManagement.tokenMechanismMasterController.getById}/${body.id}`,
        method: "GET",
        headers: { Authorization: `Bearer ${body.token}` },
      }),
    }),
    saveTokenMechanismMaster: builder.mutation({
      query: (body) => ({
        url: userManagement.tokenMechanismMasterController.save,
        method: "POST",
        body: body.payload,
        headers: { Authorization: `Bearer ${body.token}` },
      }),
    }),
    updateTokenMechanismMaster: builder.mutation({
      query: (body) => ({
        url: `${userManagement.tokenMechanismMasterController.update}/${body.payload.id}`,
        method: "PUT",
        body: body.payload,
        headers: { Authorization: `Bearer ${body.token}` },
      }),
    }),

    deleteTokenMechanismMaster: builder.mutation({
      query: (body) => ({
        url: `${userManagement.tokenMechanismMasterController.delete}/${body.id}`,
        method: "DELETE",
        headers: { Authorization: `Bearer ${body.token}` },
      }),
    }),
    searchTokenMechanismMasters: builder.mutation({
      query: (body) => ({
        url: userManagement.tokenMechanismMasterController.search,
        method: "POST",
        body: body.payload,
        headers: { Authorization: `Bearer ${body.token}` },
      }),
    }),
    getAllTokenMechanismMasterWithPagination: builder.mutation({
      query: (body) => ({
        url: `${userManagement.tokenMechanismMasterController.getAllWithPagination}/${body.payload.page}/${body.payload.offset}?orderBy=${body.payload.orderBy}`,
        method: "GET",
        headers: { Authorization: `Bearer ${body.token}` },
      }),
    }),
    bulkUploadTokenMechanismMasters: builder.mutation({
      query: (body) => {
        return {
          url: userManagement.tokenMechanismMasterController.uploadBulk,
          method: "POST",
          body: body.payload,
          headers: { Authorization: `Bearer ${body.token}` },
        };
      },
    }),

  }),
});

export const {
  useGetAllTokenMechanismMastersMutation,
  useGetTokenMechanismMasterByIdMutation,
  useSaveTokenMechanismMasterMutation,
  useUpdateTokenMechanismMasterMutation,
  useDeleteTokenMechanismMasterMutation,
  useSearchTokenMechanismMastersMutation,
  useGetAllTokenMechanismMasterWithPaginationMutation,
  useBulkUploadTokenMechanismMastersMutation,
} = tokenMechanismMasterService;
